// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quote-list-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.quote-list-container h1 {
  margin-bottom: 30px;
  color: #333;
}

.error-message {
  background-color: #fee;
  color: #c33;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.summary-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  text-align: center;
}

.summary-card h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #666;
  font-weight: normal;
}

.summary-card p {
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  color: #1976d2;
}

.summary-card.warning p {
  color: #f57c00;
}

.summary-card.info p {
  color: #0288d1;
}

.empty-quotes {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.empty-quotes p {
  margin: 10px 0;
}

.empty-quotes .text-muted {
  color: #666;
  font-size: 14px;
}

.quote-table {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
}

.quote-table table {
  width: 100%;
  border-collapse: collapse;
}

.quote-table th {
  background-color: #f5f5f5;
  padding: 15px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #e0e0e0;
}

.quote-table td {
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.quote-table tr:last-child td {
  border-bottom: none;
}

.quote-table tr:hover {
  background-color: #f9f9f9;
}

.badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
}

.badge-primary {
  background-color: #1976d2;
  color: white;
}

.badge-warning {
  background-color: #f57c00;
  color: white;
}

.badge-success {
  background-color: #388e3c;
  color: white;
}

.badge-danger {
  background-color: #d32f2f;
  color: white;
}

.badge-secondary {
  background-color: #757575;
  color: white;
}

.badge-info {
  background-color: #0288d1;
  color: white;
}

.text-warning {
  color: #f57c00;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.btn-view,
.btn-share {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.btn-view {
  background-color: #1976d2;
  color: white;
}

.btn-share {
  background-color: #757575;
  color: white;
}

.btn-view:hover,
.btn-share:hover {
  opacity: 0.9;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border-top: 1px solid #e0e0e0;
}

.pagination button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.pagination button:hover:not(:disabled) {
  background-color: #f5f5f5;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

.error {
  text-align: center;
  padding: 40px;
  color: #c33;
}`, "",{"version":3,"sources":["webpack://./src/components/DraftList.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb","sourcesContent":[".quote-list-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.quote-list-container h1 {\n  margin-bottom: 30px;\n  color: #333;\n}\n\n.error-message {\n  background-color: #fee;\n  color: #c33;\n  padding: 10px 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.summary-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.summary-card {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  text-align: center;\n}\n\n.summary-card h3 {\n  margin: 0 0 10px 0;\n  font-size: 16px;\n  color: #666;\n  font-weight: normal;\n}\n\n.summary-card p {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 600;\n  color: #1976d2;\n}\n\n.summary-card.warning p {\n  color: #f57c00;\n}\n\n.summary-card.info p {\n  color: #0288d1;\n}\n\n.empty-quotes {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.empty-quotes p {\n  margin: 10px 0;\n}\n\n.empty-quotes .text-muted {\n  color: #666;\n  font-size: 14px;\n}\n\n.quote-table {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\n.quote-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.quote-table th {\n  background-color: #f5f5f5;\n  padding: 15px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.quote-table td {\n  padding: 15px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.quote-table tr:last-child td {\n  border-bottom: none;\n}\n\n.quote-table tr:hover {\n  background-color: #f9f9f9;\n}\n\n.badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-block;\n}\n\n.badge-primary {\n  background-color: #1976d2;\n  color: white;\n}\n\n.badge-warning {\n  background-color: #f57c00;\n  color: white;\n}\n\n.badge-success {\n  background-color: #388e3c;\n  color: white;\n}\n\n.badge-danger {\n  background-color: #d32f2f;\n  color: white;\n}\n\n.badge-secondary {\n  background-color: #757575;\n  color: white;\n}\n\n.badge-info {\n  background-color: #0288d1;\n  color: white;\n}\n\n.text-warning {\n  color: #f57c00;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-view,\n.btn-share {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.btn-view {\n  background-color: #1976d2;\n  color: white;\n}\n\n.btn-share {\n  background-color: #757575;\n  color: white;\n}\n\n.btn-view:hover,\n.btn-share:hover {\n  opacity: 0.9;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  padding: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.pagination button {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.pagination button:hover:not(:disabled) {\n  background-color: #f5f5f5;\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.error {\n  text-align: center;\n  padding: 40px;\n  color: #c33;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
